import axios from '@/libs/api.request'

/**
 * 重置密码
 */
export const resetPass = (user_id) => {
    const data ={
        "user_id": user_id
    }
    return axios.request({
        url: '/api/admin/user/resetPassword',
        data,
        method: 'post'
    })
}

/**
 * 查询用户与角色的数据
 */
 export const getUserRoleData = (userId) => {
    const data = {
        'userId': userId
    }
    return axios.request({
        url: '/api/admin/user/role',
        data,
        method: 'post'
    })
}
